import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { Field } from '@cleartrip/bento'

import { ReactComponent as ArrowIcon } from 'assets/icons/chevron.svg'

const DropdownSelect = ({
    children,
    className,
    label,
    active,
    placeHolder,
    variant,
    onClick,
    width,
    border,
    onChange,
    hasError,
    arrow,
    isSearchDropdown,
    ...style
}) => {
    const rotatedStyle = {
        transform: `rotate(-180deg)`
    }
    const isRTL = false
    const selectClassName = classNames(
        'flex flex-1 flex-middle flex-between t-all fs-4 focus:bc-secondary-500 bg-white',
        {
            'bc-secondary-500': active,
            'bc-neutral-100': !active && !hasError,
            'c-pointer': variant === 'select',
            'pr-2 pl-2 pt-2 pb-2 ba br-4 h-10': border,
            // 'pr-2 pl-3 pt-3 pb-3 ba br-4 h-8': !withoutBorder,
            'bc-error-500': hasError
        },
        className
    )
    const errorClass = classNames(
        'flex flex-middle flex-between t-all fs-2',
        {
            'pr-2 pl-3 pt-2 pb-2 ba br-4 h-8': border
        },
        className
    )
    let Arrow
    if (arrow) {
        if (active) Arrow = <ArrowIcon height={12} width={12} className={classNames('t-all c-secondary-500')} style={rotatedStyle} />
        else Arrow = <ArrowIcon height={12} width={12} className={classNames('t-all c-neutral-400')}  />
    }

    function onSearchChange(e) {
        onChange(e)
        onClick('open')
    }
    function onFieldClick(e) {
        e.target.select()
        onClick(isSearchDropdown ? 'open' : 'close')
    }
    function onSelectClick(e) {
      e.preventDefault()
      onClick(e)
    }

    return (
        <>
            {children && children}
            {variant === 'select' && !children && (
                <button
                    onClick={e => onSelectClick(e)}
                    className={selectClassName}
                    style={{
                        minWidth: `${width}px`
                    }}
                >
                    {label ? (
                        <div className="fs-inherit c-inherit flex flex-nowrap">{label}</div>
                    ) : (
                        <div className="fs-inherit c-neutral-300 flex-nowrap">{placeHolder}</div>
                    )}
                    {Arrow}
                </button>
            )}
        </>
    )
}

DropdownSelect.defaultProps = {
    variant: 'select',
    width: 104,
    active: false,
    isSearchDropdown: true,
    border: true,
    arrow: true,
    className: ''
}

DropdownSelect.propType = {
    variant: PropTypes.string,
    width: PropTypes.number,
    active: PropTypes.bool,
    border: PropTypes.bool,
    arrow: PropTypes.bool,
    className: PropTypes.string
}

export default DropdownSelect
